export function setWebsiteOpened() {
    localStorage.isOpened = true
}

export function deleteWebsiteOpened() {
    delete localStorage.isOpened
}

export function isWebsiteOpened() {
    return localStorage.isOpened
}


export function setShowHelp(showHelp) {
    try {
        localStorage.showHelp = showHelp
    } catch (e) {
    }
}

export function showHelp() {
    try {
        return localStorage.showHelp
    } catch (e) {
        return undefined
    }
}
